import Vue from 'vue';
import Vuex from 'vuex';
import apiService from '../services/apiServices.js';
import { TokenService } from '../services/storageService';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {

  },
  state: {
    token: localStorage.getItem('access_token'),
    user_name: localStorage.getItem('user_name'),
    role: localStorage.getItem('role'),
    item_type: []
  },
  getters: {
    loggedIn(state) {
      return state.token !== null;
    },
    getToken(state) {

    }
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    getItemtype: (state, item_type) => {
      state.item_type = item_type;
    },
  },
  actions: {
    destroyToken(context) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          apiService.post('logout', {
            access_token: context.getters.loggedIn,
          })
            .then((response) => {
              TokenService.removeToken();
              TokenService.removeRefreshToken();
              apiService.removeHeader();
              context.commit('destroyToken');
              resolve(response);
              console.log(response);
            })
            .catch((error) => {
              TokenService.removeToken();
              TokenService.removeRefreshToken();
              apiService.removeHeader();
              context.commit('destroyToken');
              console.log(error);
              reject(error);
            });
        });
      }
    },
    retrieveToken(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/login', payload)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(">>>>>>",response.data.data),
              localStorage.setItem('user_name', response.data.data.user_name);
              localStorage.setItem('role', response.data.data.role);
              TokenService.saveToken(response.data.data.token);
              context.commit('retrieveToken', response.data.data);
              resolve(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    forgotpass(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/user/forgot-password', payload)
          .then((response) => {
            if (response.data.code === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    postUploadData(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/sales-dashboard-segment', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getUploadData(context, payload) {
      return new Promise((resolve, reject) => {

        apiService.get('/api/v1/sales-dashboard-segment?limit=1000&page=')
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    delUploadData(context, payload) {
      console.log("hapussss", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/sales-dashboard-segment/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getUploadDataOwnership(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.get('/api/v1/sales-dashboard-ownership?limit=1000&page=')
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    postUploadDataOwnership(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/sales-dashboard-ownership', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    delUploadDataOwnership(context, payload) {
      console.log("delete ownership", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/sales-dashboard-ownership/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getUploadDataSegment(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.get('/api/v1/sales-dashboard-segment?limit=1000&page=')
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    postUploadDataSegment(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/sales-dashboard-segment', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    delUploadDataSegment(context, payload) {
      console.log("delete ownership", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/sales-dashboard-segment/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getUploadDataTarget(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.get('/api/v1/sales-dashboard-target?limit=1000&page=')
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    postUploadDataTarget(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/sales-dashboard-target', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    delUploadDataTarget(context, payload) {
      //console.log("delete ownership", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/sales-dashboard-target/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getUploadDataExpensePnl(context, payload) {
      return new Promise((resolve, reject) => {
        //console.log("get expanse >>>>"+ JSON.stringify(payload))
        apiService.get(`/api/v1/expence-pnl?limit=${payload.limit}&page=${payload.page}&admin_hub=${payload.admin_hub}&date_from=${payload.date_from}&date_to=${payload.date_to}`)
          .then((response) => {
            if (response.data.code === 200) {
              //console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    delUploadDataExpensePnl(context, payload) {
      //console.log("delete ownership", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/expence-pnl/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              //console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    postUploadDataExpensePnl(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/expence-pnl', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getUploadDataUecPnl(context, payload) {
      return new Promise((resolve, reject) => {
        //console.log("store "+ payload.origin)
        apiService.get(`/api/v1/uec-dashboard?limit=${payload.limit}&page=${payload.page}&f_origin=${payload.origin}&f_destination=${payload.destination}&f_service=${payload.service}`)
          .then((response) => {
            if (response.data.code === 200) {
              // console.log(response.data.data.records)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    delUploadDataUecPnl(context, payload) {
      //console.log("delete ownership", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/uec-dashboard/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    postUploadDataUecPnl(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/api/v1/uec-dashboard', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    postCreateTableauLink(context, payload) {
      return new Promise((resolve, reject) => {
        console.log("add user", payload)
        apiService.post('/api/v1/bi-dashboard-tableau', payload)
          .then((response) => {
            if (response.data.code === 200) {

              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    getAllTableauLinks(context, payload) {
      return new Promise((resolve, reject) => {
        //console.log("get tableau links "+ JSON.stringify(payload))
        apiService.get(`/api/v1/bi-dashboard-tableau?limit=${payload.limit}&page=${payload.page}`)
          .then((response) => {
            if (response.data.code === 200) {
              //console.log("ini di store..."+ JSON.stringify(response.data.data))
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    editTableauLink(context, payload) {
      //console.log("get user",payload)
      return new Promise((resolve, reject) => {
        apiService.get(`/api/v1/bi-dashboard-tableau?id=${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              //console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    updateTableauLink(context, payload) {
      console.log("update tableau link", payload)
      const id = payload.id
      // const items = JSON.stringify({
      //   purpose: payload[0]["purpose"],
      //   admin_hub_code: payload[0]["admin_hub_code"],
      //   role: payload[0]["role"],
      //   link: payload[0]["link"],
      //   uploaded_by: payload[0]["uploaded_by"]
      // })

      console.log("id", id)
      console.log("payload", payload)
      return new Promise((resolve, reject) => {
        apiService.put(`/api/v1/bi-dashboard-tableau/${id}`, payload)
          .then((response) => {
            if (response.data.code === 200) {
              //console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },
    deleteTableauLink(context, payload) {
      console.log("delete user", payload)
      return new Promise((resolve, reject) => {
        apiService.delete(`/api/v1/bi-dashboard-tableau/${payload}`)
          .then((response) => {
            if (response.data.code === 200) {
              console.log(response)
              resolve(response);
            }

          })
          .catch((error) => {
            reject(error);
            console.log(error);
          });
      });
    },


  },
});
